import { useState } from "react";
import { useEffect } from "react";
import LoadingScreen from "../components/LoadingScreen/LoadingScreen";
import { Container, Row, Col, Button } from 'react-bootstrap';
import ReactSelect from 'react-select';
import TableView from './../components/TableViews/TableView'
import { Link, useLocation, useNavigate } from 'react-router-dom';
import axios from "axios";
import NoResult from "../components/NoResult";

const GetStoreProducts = () => {
    const loc = useLocation();
    const storeId = loc.state.id;
    const [products, setProducts] = useState([]);
    const [toggle, refreshPage] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [search, setSearch] = useState("");
    const [typeFilter, setTypeFilter] = useState();
    const [orderBy, setOrderBy] = useState({ created_at: 'DESC' })
    const DELAY_TIME = 500;
    const navigate = useNavigate()

    const handleTypeFilter = (e) => {
        setTypeFilter(e.value)
    }

    const handleResetFilters = () => {
        setTypeFilter();
        setSearch("")
    }

    useEffect(() => {
        const pageTimeout = setTimeout(() => {
            let filterObj = {};
            // let quantityObj = {};
            if (search && Object.keys(search).length > 0) {
                filterObj = { ...filterObj, product_name: search }
            }
            let quantityObj = {}
            if (typeFilter === 'sold') {
                quantityObj['quantity'] = typeFilter;
            }
            if (typeFilter === 'available') {
                quantityObj['quantity'] = typeFilter;
            }
            let searchObj = { ...quantityObj, ...filterObj }
            axios.post(process.env.REACT_APP_FIND_API_URL + `/store-products/get-store-products/${storeId}`, { ...searchObj }, { withCredentials: true }).then((res) => {
                console.log(res);
                setIsLoading(false)
                setProducts(res.data.data)
            }).catch((err) => {
                setIsLoading(false)
                console.log(err);
            })
        }, DELAY_TIME);
        return () => {
            clearTimeout(pageTimeout)
        }
    }, [storeId, search, toggle, typeFilter]);

    const edit = (id) => {
        navigate(`/admin/edit-store-products/${id}`);
    }

    const remove = (id) => {
        axios.delete(process.env.REACT_APP_FIND_API_URL + '/store-products/delete-store-product/' + id, { withCredentials: true }).then(() => {
            refreshPage(prev => !prev)
        })
    }
    return (
        <>
            {
                isLoading ? (
                    <LoadingScreen />
                ) :
                    <Container fluid>
                        <Row className='mb-2'>
                            <Col md="3">
                                <div className="topnav__search">
                                    <input type="text" placeholder='Search here...' onChange={(e) => setSearch(e.target.value)} />
                                    <i className='bx bx-search'></i>
                                </div>
                            </Col>
                            <Col md="3"></Col>
                            <Col md="3">
                                {/* <ReactSelect options={type} onChange={(e) => handleTypeFilter(e)} /> */}
                                <ReactSelect options={[{ value: 'sold', label: 'Sold' }, { value: 'available', label: 'Available' }]} onChange={(e) => handleTypeFilter(e)} />
                            </Col>
                            <Col md="3" className='text-end'>
                                <Link to='/admin/add-store-products'>
                                    <Button>Add Products +</Button>
                                </Link>
                            </Col>
                        </Row>
                        <Button className="mb-5" onClick={() => handleResetFilters()}>Reset Filters</Button>
                        {


                            !products[0] ?
                                <NoResult name="products" link={'/admin/add-store-products'} /> :

                                (<>
                                    <TableView
                                        data={products}
                                        edit={edit}
                                        remove={remove}
                                        columnNotShow={['images', 'id']}
                                        dateColumn={['created_at']}
                                        sortColumn={['category_name', 'created_at']}
                                        orderBy={orderBy}
                                        setOrderBy={setOrderBy}
                                        status={{
                                            column: 'quantity',
                                            style: (value) => {
                                                if (value > 0) {
                                                    return 'text-success'
                                                } else {
                                                    return 'text-danger'
                                                }
                                            },
                                            format: (value) => {
                                                if (value > 0) {
                                                    return 'Available';
                                                } else {
                                                    return 'Sold';
                                                }
                                            }
                                        }}
                                    />
                                </>)}
                    </Container>
            }
        </>
    );
}

export default GetStoreProducts;